<template>
    <div>
      <Export_product_detail/>
    </div>
  </template>
  
  <script>
  import Export_product_detail from "@/components/adminArin/pos_system/warehouse/export_product/Export_product_detail";
  export default {
    name: "exportproductdetail",
    components: {
        Export_product_detail
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  